import { doAttention } from '@/attention';
export function tada(el, duration = undefined, options = {}) {
    return doAttention(el, 'tada', duration, options);
}
//# sourceMappingURL=tada.js.map